import { Mark, Product } from '../types/product';
import DeleteOutline from './icons/DeleteOutline';
import PencilOutline from './icons/PencilOutline';
import Badge from './ui/Badge';
import IconButton from './ui/IconButton';

type ProductComponentProps = {
  product: Product;
  onClick?: (id: string) => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  withMarks?: boolean;
};

export function translateMark(mark: Mark) {
  switch (mark) {
    case 'BOUGHT':
      return 'Gekauft';
    case 'RESERVED':
      return 'Reserviert';
    default:
      return '-';
  }
}

const ProductComponent = (props: ProductComponentProps) => {
  return (
    <li
      className={`py-4 flex justify-between align-center ${props.onClick ? 'cursor-pointer' : ''}`}
      onClick={() => props.onClick && props.onClick(props.product.id)}
    >
      <div className="flex">
        {props.product.imageUrl ? (
          <div
            style={{
              backgroundImage: `url(${props.product.imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
            className="h-10 w-10 rounded-full shrink-0"
          />
        ) : (
          <span className="flex flex-col h-10 w-10 bg-white rounded-full justify-center text-center shrink-0">
            {props.product.name[0]}
          </span>
        )}

        <div className="ml-3 flex flex-col justify-center">
          <p
            className={`text-sm font-medium text-white ${
              props.withMarks && props.product.marked?.mark === 'BOUGHT' ? 'line-through' : ''
            }`}
          >
            {props.product.name}
          </p>
          {props.product.price ? (
            <p className="text-sm text-gray-500">{props.product.price.toLocaleString()} €</p>
          ) : null}
        </div>
      </div>

      <div className="ml-3 align-end space-x-2 shrink-0">
        {props.withMarks && props.product.marked?.mark && <Badge>{translateMark(props.product.marked.mark)}</Badge>}
        {props.onEdit ? (
          <IconButton
            Icon={PencilOutline}
            variant="primary-muted"
            onClick={(e) => {
              e.stopPropagation();
              props.onEdit && props.onEdit(props.product.id);
            }}
          />
        ) : undefined}
        {props.onDelete ? (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              props.onDelete && props.onDelete(props.product.id);
            }}
            Icon={DeleteOutline}
            variant="danger-muted"
          />
        ) : undefined}
      </div>
    </li>
  );
};

export default ProductComponent;
